// extracted by mini-css-extract-plugin
export default {"modal-header":"AddInventoryModell_modal-header__22uqG","search-filter__markReceived":"AddInventoryModell_search-filter__markReceived__f2+Db"};